import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { PrinterFetchAPI } from '../../../api/Printer';
import { Badge } from 'react-bootstrap';
import { ListGroup } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import LoadingAlert from '../../Alerts/LoadingAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
import './ModalEditIp.css'


const ModalEditIp = ({ printer, setEventHandle }) => {
    const [showModalEditIp, setshowModalEditIp] = useState(false)
    const [ip_Update, setIp_Update] = useState("")
    let token = localStorage.getItem('x-access-machine-token');
    let machine = localStorage.getItem('machine');

    if (machine != undefined || machine != null || machine != "") {
        machine = JSON.parse(localStorage.getItem('machine'));
    }

    //function action print order
    const UpdatePrinterIp = async () => {
        LoadingAlert()
        try {
            const response = await PrinterFetchAPI.updateIpPrinter(token, machine.id, printer.printer_id, ip_Update);
            console.log(response);
            ErrorAlert("Ip actualizada con exito", " Exito", "success")
            setEventHandle(1)
            setshowModalEditIp(false);

        } catch (err) {
            ErrorAlert("Error", "Ocurrio un error", "error")
            console.log(err);
        }
    }

    return (
        <>


            <button className="sp-cfg__btn sp-cfg__btn--primary" onClick={() => (setshowModalEditIp(true))}>
                <i className="uil uil-edit"></i> Editar IP
            </button>

            <Modal
                show={showModalEditIp}
                onHide={() => setshowModalEditIp(false)}
                size="sm-down"
                centered
            >
                <Modal.Body className="sp-cfgmini rounded-5">
                    <div className="sp-cfgmini__head">
                        <div className="sp-cfg__badge sp-cfg__badge--sm"><i className="uil uil-print"></i></div>
                        <h5 className="sp-cfgmini__title">{printer.printer_name}</h5>
                        <button className="sp-cfg__x" type="button" aria-label="Cerrar" onClick={() => setshowModalEditIp(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>

                    <h3 className="sp-eip__subtitle"><i className="uil uil-edit"></i> Editar IP address</h3>

                    <div className="sp-cfgmini__field">
                        <label className="sp-cfg__label">Dirección IP:</label>
                        <input
                            type="text"
                            className="sp-cfg__input"
                            placeholder={printer.ip}
                            onChange={(e) => (setIp_Update(e.target.value))}
                        />
                    </div>

                    <div className="sp-cfgmini__acts sp-cfgmini__acts--split">
                        <button className="sp-cfg__btn sp-cfg__btn--danger" onClick={() => setshowModalEditIp(false)}>Cancelar</button>
                        <button className="sp-cfg__btn sp-cfg__btn--ok" onClick={async () => (UpdatePrinterIp())}>Guardar</button>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}

export default ModalEditIp